import React from 'react';
import { BookOpenCheckIcon, FileTextIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { HERO_IMAGE, stats, trustBadges } from '../../data/content';
const badgeIcons = [BookOpenCheckIcon, FileTextIcon, ZapIcon];
export function Hero() {
  return <section className="w-full bg-white px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-12" data-id="element-194" data-mp="huo1s3i8mgqz">
      <div className="mx-auto max-w-4xl" data-id="element-195" data-mp="hsl3yxaufjbp">
        <p className="text-center font-display text-lg font-bold tracking-tight text-navy-900 sm:text-xl" data-id="element-196" data-mp="mszbme8j8r97">
          Dr. <span className="text-brick-600" data-id="element-197" data-mp="qub2so721kji">Karito</span>
        </p>

        <h1 className="mt-5 text-balance text-center font-display text-[30px] font-bold leading-[1.1] text-navy-900 sm:mt-7 sm:text-5xl lg:text-[58px]" data-id="element-198" data-mp="vlu8ajjxpend">
          Make confident decisions for any patient with kidney disease in{' '}
          <em className="italic text-brick-600" data-id="element-199" data-mp="15ltdq7l24ow0">under 5 minutes</em>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-navy-600 sm:mt-6 sm:text-lg" data-id="element-200" data-mp="1aitk6jltjtnn">
          From interpreting an elevated creatinine to deciding whether to treat, monitor, adjust, or
          refer — without searching through multiple guidelines or second-guessing yourself during
          the visit.
        </p>

        <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-semibold leading-relaxed text-navy-500 sm:text-[15px]" data-id="element-201" data-mp="3rtfhwl0jitoy">
          More than 1,000 physicians already use Kidney Disease Route™ to turn clinical uncertainty
          into clear, structured decisions backed by evidence.
        </p>

        <div className="mt-7 sm:mt-9" data-id="element-202" data-mp="io90ozp53cij">
          <img src={HERO_IMAGE} alt="Kidney Disease Route™ — 6 clinical volumes plus 5 premium bonuses shown on tablet and phone" className="mx-auto w-full max-w-2xl" loading="eager" data-id="element-203" data-mp="in69srrtha2m" />
          <p className="mt-1 text-center text-[11px] font-extrabold uppercase tracking-[0.14em] text-navy-400 sm:text-xs" data-id="element-204" data-mp="1b6mmu2145a1s">
            6 volumes + 5 premium bonuses
          </p>
        </div>

        <div className="mt-8 sm:mt-10" data-id="element-205" data-mp="30o9uskx1ih8p">
          <CTAButton id="primary-cta" label="I want Kidney Disease Route™" subline="Instant download • One-time payment • Lifetime access • 7-day guarantee" data-id="element-206" data-mp="35la20z5mlq1e" />
        </div>

        <ul className="mx-auto mt-9 grid max-w-3xl grid-cols-1 gap-3 sm:mt-12 sm:grid-cols-3" data-id="element-207" data-mp="2vtw58z5274by">
          {trustBadges.map((badge, index) => {
          const Icon = badgeIcons[index];
          return <li key={badge.title} className="flex items-center gap-3 rounded-2xl border border-navy-100 bg-cream px-4 py-3.5 sm:flex-col sm:gap-2 sm:px-4 sm:py-5 sm:text-center" data-id="element-208" data-mp="2mw3pjtvfduo1" data-mpi={index}>
                <Icon className="h-5 w-5 shrink-0 text-brick-600" aria-hidden="true" data-id="element-209" data-mp="2cy60x59nlvuw" />
                <div data-id="element-210" data-mp="63shl1uxk4k6">
                  <p className="text-[14px] font-bold leading-snug text-navy-900 sm:text-[15px]" data-id="element-211" data-mp="b4zuffbxjtxp">
                    {badge.title}
                  </p>
                  <p className="mt-0.5 text-[12.5px] font-medium leading-snug text-navy-500 sm:text-[13px]" data-id="element-212" data-mp="1vnk02lj9h90c">
                    {badge.description}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto mt-10 max-w-4xl border-t border-navy-100 pt-8 sm:mt-14 sm:pt-10" data-id="element-213" data-mp="20llkb9sfbede">
        <dl className="grid grid-cols-2 gap-y-6 text-center sm:grid-cols-5 sm:gap-y-0" data-id="element-214" data-mp="2ecz1ih2v0059">
          {stats.map(stat => <div key={stat.label} className="px-2 last:col-span-2 sm:last:col-span-1" data-id="element-215" data-mp="2aavdksz07333">
              <dt className="sr-only" data-id="element-216" data-mp="2oby1zcdh0ph6">{stat.label}</dt>
              <dd data-id="element-217" data-mp="2o9btnaira5xw">
                <span className="block font-display text-2xl font-bold leading-none text-navy-900 sm:text-3xl" data-id="element-218" data-mp="2jcutfhya814g">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10.5px] font-bold uppercase tracking-[0.1em] text-navy-500 sm:text-[11px]" data-id="element-219" data-mp="txwzmhippkcc">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}